import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@entur/tab'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { space } from '@entur/tokens'
import { Contrast } from '@entur/layout'
import { Heading1 } from '@entur/typography'
import FipReportTab from '../components/reports/fip-report-tab'
import { HistoryState } from '../types'
import TicketsWithoutsTicketRightReportTab from '../components/reports/tickets-withouts-ticket-right-report-tab'
import StopPlaceTicketRightTab from '../components/reports/stop-place-ticket-right-tab'
import ApprenticeTicketRightTab from '../components/reports/apprentice-ticket-right-tab'

const tabs = [
  {
    hash: 'utenlandsreiser',
    title: 'Utenlandsreiser',
    component: <FipReportTab />,
  },
  {
    hash: 'billetterutenrettighet',
    title: 'Billetter uten rettighet',
    component: <TicketsWithoutsTicketRightReportTab />,
  },
  {
    hash: 'strekningsrettigheter',
    title: 'Strekningsrettigheter',
    component: <StopPlaceTicketRightTab />,
  },
  {
    hash: 'larlingsrettigheter',
    title: 'Lærlingrettigheter',
    component: <ApprenticeTicketRightTab />,
  },
]

const ReportTabPanels: React.FC = () => {
  return (
    <div style={{ position: 'relative' }}>
      <TabPanels style={{ paddingTop: space.large, paddingLeft: 0, paddingRight: 0 }}>
        {tabs.map((tab) => (
          <TabPanel>{tab.component}</TabPanel>
        ))}
      </TabPanels>
    </div>
  )
}

const ReportsPage: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const locState = location.state as HistoryState

  const currentTabIndex = tabs.findIndex((t) => `#${t.hash}` === location.hash)

  return (
    <>
      <Contrast className="eds-contrast full-width-div">
        <div className="auto-margin">
          <Heading1>Rapporter</Heading1>
        </div>
      </Contrast>
      <Tabs
        style={{ clear: 'both' }}
        index={currentTabIndex !== -1 ? currentTabIndex : 0}
        onChange={(newIndex) => {
          navigate(`/rapporter#${tabs[newIndex].hash}`, { state: locState, replace: true })
        }}
      >
        <TabList>
          {tabs.map((tab) => (
            <Tab data-cy={`${tab.hash}-tab-button`}>{tab.title}</Tab>
          ))}
        </TabList>
        <ReportTabPanels />
      </Tabs>
    </>
  )
}

export default ReportsPage
